import { GridColDef } from "@mui/x-data-grid";
import dayjs from "dayjs";

import { ActionUnlock } from "./ActionUnlock";
import { Status } from "./Status";
import DataGridTextHeader from "../../molecules/DataGridTextHeader";

export const customerColumns: GridColDef[] = [
  {
    field: "omneId",
    headerName: "Omne ID",
    width: 350,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "signupCountry",
    headerName: "Signup country",
    width: 90,
    sortable: false,
    disableColumnMenu: true,
    renderHeader: DataGridTextHeader,
  },
  {
    field: "accountCreationDate",
    headerName: "Account Creation date",
    width: 150,
    disableColumnMenu: true,
    renderHeader: DataGridTextHeader,
  },
  {
    field: "omneName",
    headerName: "OMNE name",
    width: 235,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "registration",
    headerName: "Omne Registration Phone/Email",
    width: 248,
    sortable: false,
    disableColumnMenu: true,
    renderCell: item =>
      item.row.primaryLoginAttribute === "Email" ? item.row.email : item.row.phoneNumber,
  },
  {
    field: "dob",
    headerName: "DOB",
    width: 108,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "gender",
    headerName: "Gender",
    width: 80,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "insuranceLinkedDate",
    headerName: "Insurance linked date",
    width: 130,
    disableColumnMenu: true,
    renderHeader: DataGridTextHeader,
    valueGetter: ({ value }) =>
    value && dayjs(value).format("DD/MM/YYYY"),
  },
  {
    field: "campaignCode",
    headerName: "Campaign code",
    width: 90,
    sortable: false,
    disableColumnMenu: true,
    renderHeader: DataGridTextHeader,
  },
  {
    field: "accountStatus",
    headerName: "Status",
    width: 117,
    sortable: false,
    disableColumnMenu: true,
    headerAlign: "center",
    renderCell: item => Status(item.row?.accountStatus),
  },
  {
    field: "action",
    headerName: "Action",
    width: 107,
    sortable: false,
    disableColumnMenu: true,
    headerAlign: "center",
    renderCell: item => ActionUnlock(item.id, item.row?.accountStatus),
  },
];
